import { useMutation } from "@tanstack/react-query";
import type {
  AuthOrderLinkCreateCodeRequestType,
  AuthOrderLinkCreateCodeResponseType,
} from "@sellar-io/api-v2/types";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";

export const useAuthCreateOrderLinkSignupCode = () => {
  return useMutation({
    mutationFn: (request: {
      data: AuthOrderLinkCreateCodeRequestType;
      orderFlowToken: string;
    }) =>
      apiV2Request({
        user: undefined,
        business: null,
        method: "post",
        path: `auth/order-link/create-signup-code`,
        data: request.data,
        headers: {
          authorization: `Bearer ${request.orderFlowToken}`,
        },
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as AuthOrderLinkCreateCodeResponseType,
      ),
  });
};
